<template>
  <a-layout>
    <a-card class="m-t-10" :bordered='false'>
      <a-button size='small' @click="$router.push({path:'/qrcode/batch/index',query:{active:3}})">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 card_title">添加产品赋码</span>
    </a-card>
    <a-card :bordered="false">
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <!-- <normalBatchs type="normal" v-model:value="search.batch_sn" required mode="multiple" v-on:change="batchChange" /> -->
        <modalBatchs type="normal" v-model:value="search.batch_sn" required mode="multiple" v-on:change="batchChange"></modalBatchs>
        <a-form-item label="区间数量" v-if="search.batch_sn.length == 1">
          <a-checkbox v-model:checked="form.set_serial_number" @change='form.set_serial_number = form.set_serial_number ? 1 : 0'><span class="s_c666 s_fonts14">设置该批次下的流水号范围（仅针对带有对应流水号的码生效！)</span> </a-checkbox>
          <div v-if="form.set_serial_number">
            <a-form-item name='serial_type' style='margin-bottom: 0;'>
              <a-radio-group v-model:value="form.serial_type">
                <a-radio :value="1">自定义流水号范围</a-radio>
                <a-radio :value="2">按营销活动范围</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item name='custom_type' style='margin-bottom: 0;' v-if="batch.small_serial_start && form.serial_type==1">
              <a-card :bordered="false" style="background-color:#f5f5f5;margin-top:10px">
                <batchInterval pattern="vertical" :small_serial_start="batch.small_serial_start" :small_serial_end="batch.small_serial_end" v-model:start="form.small_serial_start" v-model:end="form.small_serial_end" />
                <a-form-item label="区间数量" v-if="form.small_serial_end">
                  {{form.small_serial_end-form.small_serial_start+1}}
                </a-form-item>
              </a-card>
            </a-form-item>

            <a-form-item name='activitys_type' style='margin-bottom: 0;' v-if="form.serial_type==2" :wrapper-col="{ span: 24, offset: 0}">
              <a-card :bordered="false" style="background-color:#f5f5f5;margin-top:10px">
                <div>
                  <span>扫码活动：</span>
                  <a-input class="m-r-10" v-model:value="form.activity_name" style="width:250px" placeholder="活动ID、活动主题"></a-input>
                  <a-button type="primary" @click='showActivity = true'>选择</a-button>
                </div>
                <selectActivitys class="m-t-20" v-if="showRange && !showActivity" :activitysList='activitysList' :activity_id='form.activity_id' :batch_sn='select_batch_sn' v-on:select="activitysChange"></selectActivitys>
              </a-card>
            </a-form-item>
          </div>
        </a-form-item>
        <a-form-item label="关联商品" name='product_name'>
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input readonly v-model:value="form.product_name" placeholder='请选择关联商品' />
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="visible=true">选择</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 3}">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-modal :keyboard="false" title="选择商品" centered v-model:visible="visible" :footer="null" width="1000px">
      <selectGood v-on:select="select" :selectList='goodList' :checkout="false" />
    </a-modal>
    <a-modal :keyboard="false" title="选择活动" centered v-model:visible="showActivity" :footer="null" width="1000px">
      <selectActivity v-on:select="activitySelect" :checkout='false' />
    </a-modal>
  </a-layout>
</template>

<script>
import { ref, reactive, toRefs, onMounted, inject } from "vue";
import { codeProductsCreate } from "@/api/qrcode";
import { activitys } from "@/api/qrcodeActivitys";
import selectActivitys from "../selectActivitys/index";
import { LeftOutlined } from "@ant-design/icons-vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import modalBatchs from './components/modalBatchs'
export default {
  // 
  components: { selectActivitys, LeftOutlined,modalBatchs },
  name: "codeProduct",
  setup() {
    let set_serial_number = async () => {
      if (!form.value.set_serial_number) {
        return Promise.reject("请设置该批次下的流水号范围！");
      } else {
        return Promise.resolve();
      }
    };
    let custom_type = async () => {
      if (
        !form.value.serial_type == 1 &&
        (form.value.small_serial_start == "" ||
          form.value.small_serial_end == "")
      ) {
        return Promise.reject("请输入起始流水号或者结束流水号！");
      } else {
        return Promise.resolve();
      }
    };
    let activitys_type = async () => {
      if (!form.value.serial_type == 2 && !state.activitysList.length) {
        return Promise.reject("请选择营销活动！");
      } else {
        return Promise.resolve();
      }
    };
    const form = ref({
      product_name: "",
      product_id: "",
      small_serial_end: "",
      small_serial_start: "",
      serial_type: "",
      batch_sns: [],
      set_serial_number: 0,
      serial_numbers: [],
      activity_id: "",
      activity_name: "",
    });
    const search = ref({
      batch_sn: [],
    });
    const state = reactive({
      showActivity: false,
      showRange: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 9 },
      goodList: [],
      activitysList: [],
      select_batch_sn: "",
      rules: {
        batch_sn: [{ required: true, message: "请选择批次！" }],
        product_name: [{ required: true, message: "请选择商品！" }],
        set_serial_number: [{ required: true, validator: set_serial_number }],
        serial_type: [{ required: true, message: "请选择流水号范围类型！" }],
        custom_type: [{ required: true, validator: custom_type }],
        activitys_type: [{ required: true, validator: activitys_type }],
      },
    });
    const visible = ref(false);
    // 用于记录 选中的批次 数据
    const batch = ref({});
    //选择批次
    const batchChange = (data) => {
       if(data.length==0){
         batch.value = [];
         state.select_batch_sn =[]
       }else{
         batch.value = data[0];
         state.select_batch_sn = data[0].batch_sn;
         search.value.batch_sn = data.map((v) => v.batch_sn);
         console.log(search.value.batch_sn,'222222')
       }
    };
    //选择商品
    const select = (e) => {
      visible.value = false;
      state.goodList = [e];
      form.value.product_name = e.product_name;
      form.value.product_id = e.id;
    };
    // 选择营销活动范围
    const activitysChange = (e) => {
      state.activitysList = e;
      console.log(state.activitysList);
    };
    const activitySelect = (data) => {
      form.value.activity_id = data.activity_id;
      form.value.activity_name = data.activity_name;
      state.showActivity = false;
      state.showRange = true;
    };
    const ruleForm = ref();
    const $router = inject("$router");
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          const hide = message.loading("正在加载中...", 0);
          form.value.serial_numbers = [];
          if (search.value.batch_sn.length == 1) {
            if (form.value.serial_type == 1) {
              form.value.serial_numbers = [
                {
                  serial_start: form.value.small_serial_start,
                  serial_end: form.value.small_serial_end,
                },
              ];
            } else {
              state.activitysList.forEach((v) => {
                var item = {
                  serial_start: v.split("-")[0],
                  serial_end: v.split("-")[1],
                };
                form.value.serial_numbers.push(item);
              });
            }
          }
          let res = await codeProductsCreate({
            ...form.value,
            batch_sns: search.value.batch_sn,
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res)) {
            message.success(res.message);
            setTimeout(() => {
              $router.go(-1);
            }, 2000);
          } else {
            message.error(res.message);
          }
          setTimeout(hide);
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    return {
      ...toRefs(state),
      form,
      search,
      batch,
      batchChange,
      visible,
      select,
      onSubmit,
      ruleForm,
      activitysChange,
      activitySelect,
    };
  },
};
</script>